module.exports = __webpack_public_path__ + "img/ordericon.368880ea.png";